import { render, staticRenderFns } from "./LandingTextarea.vue?vue&type=template&id=1fb243de&scoped=true&"
import script from "./LandingTextarea.vue?vue&type=script&lang=ts&"
export * from "./LandingTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./LandingTextarea.vue?vue&type=style&index=0&id=1fb243de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb243de",
  null
  
)

export default component.exports